module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="fmcy-menu-item-price-quantity">\n    '+
((__t=( quantity ))==null?'':__t)+
'\n</div>\n';
 if (onSale) { 
__p+='\n<div class="fmcy-menu-item-price-label">regular</div>\n<div class="fmcy-menu-item-price-regular fmcy-menu-item-price-amount">\n    <span class="fmcy-dollar-sign">$</span>'+
((__t=( regularPrice ))==null?'':__t)+
'\n</div>\n<div>\n  <div class="fmcy-menu-item-price-label-now fmcy-menu-item-price-label">now</div>\n  <div class="fmcy-menu-item-price-actual fmcy-menu-item-price-amount">\n      <span class="fmcy-dollar-sign">$</span>'+
((__t=( price ))==null?'':__t)+
'\n  </div>\n  <div class="fmcy-menu-item-price-label-save fmcy-menu-item-price-label">save</div>\n  <div class="fmcy-menu-item-price-save fmcy-menu-item-price-amount">\n      <span class="fmcy-dollar-sign">$</span>'+
((__t=( saved ))==null?'':__t)+
'\n  </div>\n</div>\n';
 } else { 
__p+='\n<div class="fmcy-menu-item-price-actual fmcy-menu-item-price-amount">\n    <span class="fmcy-dollar-sign">$</span>'+
((__t=( price ))==null?'':__t)+
'\n</div>\n';
 } 
__p+='\n<div class="fmcy-menu-item-price-added">\n    <div>+</div>\n</div>\n<div class="fmcy-menu-item-price-buy-button">\n    ADD\n</div>\n';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/menu/common/menu-item-prices/menu-item-price/menu-item-price-promotion.html
 ** module id = 120
 ** module chunks = 1 2 3 4 5 6 7 10 11 13 16 17 22 25 26 87 98 151
 **/